import {
  forwardRef,
  ForwardRefRenderFunction,
  ForwardedRef,
  useEffect,
  RefObject,
  useRef,
  useImperativeHandle,
} from 'react';
import { ExitIcon } from '@vfit/shared-icons';
import { IModalProps } from '../../modal.models';
import * as S from './defaultModal.style';
import { CloseBtnHandle } from 'libs/shared/components/src/lib/ModalWrappers/interfaces';

const DefaultModalWithRef: ForwardRefRenderFunction<CloseBtnHandle, IModalProps> = (
  {
    children,
    onCloseModal,
    isDetailsModal,
    withBorderRadius,
    height,
    tabletMode,
    customId,
    isDisabledClose,
    variant,
  }: IModalProps,
  ref: ForwardedRef<CloseBtnHandle>
) => {
  const closeBtnRef = useRef<HTMLDivElement | null>(null);
  //auto focus x button when active modal
  // useEffect(() => {
  //   (
  //     closeBtnRef?.current?.querySelector('span, [tabindex]:not([tabindex="-1"])') as HTMLElement
  //   )?.focus();
  // }, []);
  const checkFocus = () => {
    return closeBtnRef.current === document.activeElement;
  };
  useImperativeHandle(
    ref,
    () => ({
      focusCloseBtn: () => {
        (
          closeBtnRef?.current?.querySelector(
            'span, [tabindex]:not([tabindex="-1"])'
          ) as HTMLElement
        )?.focus();
      },
      hasFocus: checkFocus,
    }),
    []
  );
  return (
    <>
      <S.Background onClick={() => onCloseModal?.()}></S.Background>
      <S.Container
        id={customId}
        isDetailsModal={isDetailsModal}
        withBorderRadius={withBorderRadius || false}
        tabletMode={tabletMode}
        maxHeight={height}
        variant={variant}
      >
        {!isDisabledClose && (
          <section id={`${customId}-closing-icon-container`} ref={closeBtnRef}>
            <span
              role="button"
              tabIndex={0}
              className="closing-icon"
              onClick={() => onCloseModal?.()}
              /* ref={ref as RefObject<HTMLElement>} */
              /* onKeyDown={() => onCloseModal?.()} */
              onKeyDown={(e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                  e.preventDefault();
                  onCloseModal?.();
                }
              }}
            >
              <ExitIcon />
            </span>
          </section>
        )}
        <S.ModalContent className="modalContent" height={height}>
          <S.Padder>{children}</S.Padder>
        </S.ModalContent>
      </S.Container>
    </>
  );
};
export const DefaultModal = forwardRef<CloseBtnHandle, IModalProps>(DefaultModalWithRef);

